// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Settings-Main-Container {
  margin-top: 32px;
}
.Settings-main-container {
  margin-top: 7px;
}
.Settings-Container001{
  padding: 0px 24px;
}
.Ticket-container-render{
  padding: 0px 24px;
}
.Ticket-text {
  color: #061522;

  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 75% */
}
.Ticket-main-header {
  align-items: center;
  margin-top: 33px;
  /* cursor: pointer; */
}
.Ticket-text-section {
  display: flex;
  gap: 24px;
}
.ticket-header-text {
  color: #405261;
  cursor: pointer;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}
.TicketHeaderActive {
  color: #061522;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  border-bottom: 1px solid #148dfd;
  padding-bottom: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/DashboardPages/Settings/style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,QAAQ;AAC7B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;AACrB","sourcesContent":[".Settings-Main-Container {\n  margin-top: 32px;\n}\n.Settings-main-container {\n  margin-top: 7px;\n}\n.Settings-Container001{\n  padding: 0px 24px;\n}\n.Ticket-container-render{\n  padding: 0px 24px;\n}\n.Ticket-text {\n  color: #061522;\n\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 75% */\n}\n.Ticket-main-header {\n  align-items: center;\n  margin-top: 33px;\n  /* cursor: pointer; */\n}\n.Ticket-text-section {\n  display: flex;\n  gap: 24px;\n}\n.ticket-header-text {\n  color: #405261;\n  cursor: pointer;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n.TicketHeaderActive {\n  color: #061522;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  border-bottom: 1px solid #148dfd;\n  padding-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
